// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorModelResponse {
    static getAttributeTypeMap() {
        return PayorModelResponse.attributeTypeMap;
    }
}
PayorModelResponse.discriminator = undefined;
PayorModelResponse.additionalProperties = false;
PayorModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PayorModel"
    },
];
//# sourceMappingURL=payorModelResponse.js.map